export default __webpack_public_path__ + "static/media/airplanemode_activeflightlocal_airport.73b1e28f.svg";